import { useCallback, useState } from "preact/hooks";

export default function usePreviewAnimations({ setMilestones, setCurrentAmount, setGoalAmount }) {
  const [isPreviewingAnimation, setIsPreviewingAnimation] = useState(false);

  const startAnimation = useCallback(
    (animation) => {
      setIsPreviewingAnimation(true);

      if (animation === "milestone") {
        // Milestone animation
        setMilestones(true);
        const timeout = setTimeout(() => {
          setMilestones(false);
          setIsPreviewingAnimation(false);
        }, 10000);
        return () => clearTimeout(timeout);
      }

      if (animation === "goal") {
        // Goal met animation
        setCurrentAmount(1000);
        const timeout = setTimeout(() => {
          setCurrentAmount(750);
          setIsPreviewingAnimation(false);
        }, 15000);
        return () => clearTimeout(timeout);
      }

      if (animation === "goalAfter") {
        // Goal after met animation
        setCurrentAmount(1200);
        setGoalAmount(1500);
        const timeout = setTimeout(() => {
          setCurrentAmount(750);
          setGoalAmount(1000);
          setIsPreviewingAnimation(false);
        }, 30000);
        return () => clearTimeout(timeout);
      }
    },
    [setCurrentAmount, setMilestones, setGoalAmount],
  );

  return {
    isPreviewingAnimation,
    startAnimation,
  };
}
